"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emitToastOnErrorService = void 0;

var _emitter = require("../../skybase-core/emitter");

var _actions = require("./actions");

var _toastrI18n = require("./toastr-i18n");

/**
 * Register an emitter to check for any param.error and show an error toast with the error message.
 * @param dispatch
 */
var emitToastOnErrorService = function emitToastOnErrorService(dispatch) {
  _emitter.SbEmitter.on('param.error', function (event) {
    var paramName = String(event.eventName).replace('param.error.', '');
    var title = {
      message: _toastrI18n.messages.toastParamErrorTitle,
      params: {
        param: paramName
      }
    };

    if (event.error && event.error.message) {
      dispatch((0, _actions.showErrorToast)({
        title: title,
        message: event.error.message
      }));
    }
  });
};

exports.emitToastOnErrorService = emitToastOnErrorService;
//# sourceMappingURL=services.js.map